import React from 'react';
import Steps from './Steps';
import { Formik, Form, Field , ErrorMessage } from "formik";
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';
import { ownerInfoSchema } from '../../../validation/validation';
import Header from '../menu/Header';
import Menu from '../menu/Menu';
const OwnerInfo = () => {

    const {setRequestStep,setOwnerInfo,ownerInfo} = useContext(userContext)

    const nextStep = (values)=>{
        setRequestStep(3)
        setOwnerInfo(values)
    }
    const previousStep = (values)=>{
        setRequestStep(1)
        setOwnerInfo(values)
    }

    return (
      <div className='expertRequest'>
      <Header/>
      <div className='d-flex request-box-content' style={{margin:"20px 30px 0px 30px"}}>
      <Menu/>
      <div className='w-100 m-1'>
      <Steps step={2}/>
      <div className='text-end m-4'>
      <Formik 
      initialValues={{
          name: ownerInfo.name || "",
          tel: ownerInfo.tel|| "",
        nationalId: ownerInfo.nationalId || "",
   
        }}
        validationSchema={ownerInfoSchema}
        onSubmit={(values , {resetForm}) => {
        nextStep(values)
        }}
        enableReinitialize={true}
      >
      {({
        isSubmitting,
        errors,
        setFieldValue,
        touched,
        values
      }) => ( 
          <Form>
          <div className="row  align-items-center ">
          <div className='col-md-6'>     
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> نام و نام خانوادگی: </label>
          <Field
          name="name"
          type="text"
          className="w-100 request-form-input"
        />
        <ErrorMessage
          name="name"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> شماره تماس : </label>
          <Field
          name="tel"
          type="text"
          className="w-100 request-form-input"
        />
        <ErrorMessage
          name="tel"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> کد ملی : </label>
          <Field
          name="nationalId"
          type="text"
          className="w-100 request-form-input"
        />
        <ErrorMessage
          name="nationalId"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          </div>
          </div>
          <div className='d-flex justify-content-between'>
          <div className=' request-next-btn-box'>
          <button  type='submit' className='btn request-next-btn' >بعدی</button>
          </div>
          <div className=' request-Previous-btn-box '>
          <button className='btn request-Previous-btn' type='button' onClick={()=>{previousStep(values)}}>قبلی</button>
          </div>
          </div>
          </Form> )}
          </Formik>
      </div>
  </div>
      </div>
      </div>
   
    );
};

export default OwnerInfo;